(function () {
  'use strict';

  var bound = false;
  var returnKey = 'lml.form.return.v1';
  var ttl = 30 * 60 * 1000;
  var captchaObserver;
  var captchaDialog;
  var captchaFramePending = false;
  var captchaSeen = false;
  var captchaTimeout;

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function modal() { return document.getElementById('LmlEnquiry'); }

  function updateViewing(form) {
    if (!form) return;
    var selected = form.querySelector('[data-viewing-format]:checked');
    var video = !!selected && selected.value === 'Video call';
    var address = form.querySelector('[data-viewing-address]');
    var note = form.querySelector('[data-viewing-video-note]');
    var timezone = form.querySelector('[data-viewing-timezone]');
    if (address) address.hidden = video;
    if (note) note.hidden = !video;
    if (timezone) {
      timezone.hidden = !video;
      each(timezone.querySelectorAll('input'), function (input) { input.disabled = !video; });
    }
  }

  function shareContact(input) {
    if (!input.closest('.lml-focused') || !['contact[Title]', 'contact[First name]', 'contact[Last name]', 'contact[email]', 'contact[Telephone]', 'contact[Company]'].includes(input.name)) return;
    each(document.querySelectorAll('.lml-focused input, .lml-focused select'), function (other) {
      if (other !== input && other.name === input.name) other.value = input.value;
    });
  }

  function showTab(m, name) {
    each(m.querySelectorAll('.lml-enq__pane'), function (pane) {
      var active = pane.dataset.pane === name;
      pane.classList.toggle('is-active', active);
      pane.hidden = !active;
    });
    m.setAttribute('aria-labelledby', 'LmlHeading-' + name);
  }

  function productContext(pane, piece, url) {
    var input = document.querySelector('.lml-prod__cart [name="id"]');
    var variantId = pane.querySelector('[data-product-variant]');
    if (!variantId) return;
    var option = pane.querySelector('[data-product-option]');
    var sku = pane.querySelector('[data-product-sku]');
    [variantId, option, sku, pane.querySelector('[name="contact[Product ID]"]')].forEach(function (field) {
      if (!field) return;
      if (field.dataset.initialValue === undefined) field.dataset.initialValue = field.defaultValue;
      field.disabled = !piece;
      field.value = piece ? field.dataset.initialValue : '';
    });
    if (!piece) return;
    if (input) variantId.value = input.value;
    var data = document.querySelector('[data-lml-variants]');
    var variant;
    try {
      variant = data && JSON.parse(data.textContent).find(function (item) { return String(item.id) === variantId.value; });
    } catch (e) {}
    if (variant) {
      if (option) option.value = variant.options.join(' / ');
      if (sku) sku.value = variant.sku || '';
    } else if (input && input.value !== variantId.dataset.initialValue) {
      if (option) option.value = '';
      if (sku) sku.value = '';
    }
    var link = pane.querySelector('[data-lml-piece-url]') || pane.querySelector('[data-focused-url]');
    if (link && url) {
      try {
        var productUrl = new URL(url, location.origin);
        if (variantId.value) productUrl.searchParams.set('variant', variantId.value);
        link.value = productUrl.href;
      } catch (e) {}
    }
    var label = pane.querySelector('[data-lml-piece-label]') || pane.querySelector('[data-focused-piece-label]');
    if (label) label.textContent = piece + (option && option.value && option.value !== 'Default Title' ? ' — ' + option.value : '');
  }

  function preparePiece(m, trigger) {
    var piece = trigger.getAttribute('data-lml-enquiry-piece') || '';
    var url = trigger.getAttribute('data-lml-enquiry-piece-url') || '';
    var reason = trigger.getAttribute('data-lml-enquiry-request') || '';
    var field = m.querySelector('[data-lml-piece]');
    var link = m.querySelector('[data-lml-piece-url]');
    var label = m.querySelector('[data-lml-piece-label]');
    var select = m.querySelector('[data-lml-piece-reason]');
    if (field) field.value = piece;
    if (link) link.value = url;
    if (label) { label.textContent = piece; label.hidden = !piece; }
    if (select) select.value = '';
    if (select && reason) each(select.options, function (option) {
      if (option.value === reason) select.value = reason;
    });
  }

  function open(tab) {
    var m = modal();
    if (!m) return false;
    if (window.lmlOverlayNav && window.lmlOverlayNav.isOpen && window.lmlOverlayNav.isOpen()) window.lmlOverlayNav.close();
    tab = tab || 'piece';
    var source = m.querySelector('[data-lml-piece]');
    var url = m.querySelector('[data-lml-piece-url]');
    var select = m.querySelector('[data-lml-piece-reason]');
    var reason = select ? select.value : '';
    var viewing = tab === 'piece' && reason === 'Request a viewing';
    var piece = source ? source.value : '';
    if (viewing) tab = 'appointment';
    if (tab === 'piece' && reason === 'Request a shipping quote') tab = 'shipping';
    if (!['appointment', 'callback', 'piece', 'shipping'].includes(tab) || !m.querySelector('[data-pane="' + tab + '"]')) tab = 'piece';
    showTab(m, tab);
    var pane = m.querySelector('[data-pane="' + tab + '"]');
    var option = tab === 'piece' && select ? select.options[select.selectedIndex] : null;
    ['heading', 'intro', 'submit'].forEach(function (part) {
      var node = pane.querySelector('[data-focused-' + part + ']');
      if (node) node.textContent = viewing ? node.dataset.viewing : (option && option.dataset[part]) || node.dataset.default;
    });
    each(m.querySelectorAll('[data-focused-piece]'), function (input) { input.value = piece; });
    each(m.querySelectorAll('[data-focused-url]'), function (input) { input.value = url ? url.value : ''; });
    each(m.querySelectorAll('[data-focused-piece-label]'), function (label) { label.textContent = piece; });
    each(m.querySelectorAll('[data-focused-product]'), function (context) { context.hidden = !piece; });
    var request = pane.querySelector('[data-focused-request]');
    if (request) request.value = tab === 'shipping' ? 'Request a shipping quote' : viewing ? reason : '';
    var type = pane.querySelector('[data-focused-type]');
    if (type) type.value = viewing ? reason : type.dataset.default;
    if (tab === 'shipping' || tab === 'piece') productContext(pane, piece, url ? url.value : '');
    setupReturns();
    if (!m.open) m.showModal();
    m.classList.add('is-open');
    document.body.classList.add('lml-enq-open');
    var active = pane.querySelector('[data-focused-heading]');
    if (active) active.focus({ preventScroll: true });
    return true;
  }

  function close() {
    var m = modal();
    if (!m) return false;
    m.close();
    m.classList.remove('is-open');
    document.body.classList.remove('lml-enq-open');
    return true;
  }

  function isOpen() { var m = modal(); return !!m && m.open; }

  function pending() {
    try {
      var value = JSON.parse(sessionStorage.getItem(returnKey));
      if (value && value.path === location.pathname && Date.now() - value.at >= 0 && Date.now() - value.at < ttl) return value.id;
    } catch (e) {}
    return '';
  }

  function clearPending() {
    try { sessionStorage.removeItem(returnKey); } catch (e) {}
  }

  function restoreForm() {
    var dialog = captchaDialog;
    captchaDialog = null;
    captchaSeen = false;
    if (captchaObserver) captchaObserver.disconnect();
    captchaObserver = null;
    clearTimeout(captchaTimeout);
    if (dialog && !dialog.open) {
      dialog.showModal();
      if (dialog.id === 'LmlEnquiry') {
        dialog.classList.add('is-open');
        document.body.classList.add('lml-enq-open');
      }
    }
  }

  function prepareSubmission(form) {
    if (captchaDialog || !form || !form.querySelector('[data-lml-form-feedback]') || !form.checkValidity()) return;
    var dialog = form.closest('dialog');
    if (!dialog || !dialog.open || typeof MutationObserver === 'undefined') return;
    captchaDialog = dialog;
    dialog.close();
    function check() {
      captchaFramePending = false;
      var visible = Array.prototype.some.call(document.querySelectorAll('iframe[src*="hcaptcha.com"][src*="frame=challenge"]'), function (frame) {
        if (!frame.getClientRects().length) return false;
        for (var node = frame; node && node !== document.body; node = node.parentElement) {
          var style = getComputedStyle(node);
          if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
        }
        return true;
      });
      if (visible) captchaSeen = true;
      else if (captchaSeen && captchaDialog) restoreForm();
    }
    captchaObserver = new MutationObserver(function () {
      if (captchaFramePending) return;
      captchaFramePending = true;
      requestAnimationFrame(check);
    });
    captchaObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    captchaTimeout = setTimeout(function () { if (!captchaSeen) restoreForm(); }, 30000);
  }

  function setupReturns() {
    each(document.querySelectorAll('[data-lml-form-feedback]'), function (feedback) {
      var form = feedback.closest('form');
      if (!form || !form.id) return;
      var input = form.querySelector('input[name="return_to"]');
      if (!input) return;
      var here = new URL(location.href);
      var target = new URL(here.pathname, here.origin);
      ['preview_theme_id', 'variant'].forEach(function (key) {
        if (here.searchParams.has(key)) target.searchParams.set(key, here.searchParams.get(key));
      });
      target.searchParams.set('contact_posted', 'true');
      target.hash = form.id;
      input.value = target.pathname + target.search + target.hash;
    });
  }

  function routeResult() {
    var hash = '';
    try { hash = decodeURIComponent(location.hash.slice(1)); } catch (e) {}
    var explicit = document.getElementById(hash);
    var form = explicit && explicit.tagName === 'FORM' && explicit.querySelector('[data-lml-form-feedback]') ? explicit : document.getElementById(pending());
    if (!form) return;
    var feedback = form.querySelector('[data-lml-form-feedback]');
    if (!feedback || feedback.dataset.routed === 'true') return;
    var state = feedback.dataset.state;
    if (state !== 'success' && state !== 'error') return;
    if (state === 'success' && new URL(location.href).searchParams.get('contact_posted') !== 'true') return;
    feedback.dataset.routed = 'true';
    feedback.hidden = false;
    form.classList.toggle('lml-form-complete', state === 'success');
    var dialog = form.closest('dialog');
    if (dialog && dialog.id === 'LmlEnquiry') {
      open(form.closest('[data-pane]').dataset.pane);
    } else if (dialog && !dialog.open) {
      dialog.showModal();
    }
    feedback.focus({ preventScroll: true });
    if (state === 'success') clearPending();
    var clean = new URL(location.href);
    clean.searchParams.delete('contact_posted');
    if (clean.hash.slice(1) === form.id || clean.hash === '#contact_form') clean.hash = '';
    history.replaceState(history.state, '', clean.pathname + clean.search + clean.hash);
  }

  function bind() {
    if (bound) return;
    bound = true;
    window.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var submit = target.closest('button[type="submit"], input[type="submit"]');
      if (submit) prepareSubmission(submit.closest('form'));
      var trigger = target.closest('[data-lml-enquiry-open]');
      if (trigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var m = modal();
        if (m) preparePiece(m, trigger);
        open(trigger.getAttribute('data-lml-enquiry-open') || null);
        return;
      }
      if (target.closest('[data-lml-enquiry-close]')) { event.preventDefault(); close(); return; }
      if (target.closest('[data-lml-feedback-close]')) {
        var dialog = target.closest('dialog');
        if (dialog && dialog.id === 'LmlEnquiry') close();
        else if (dialog) dialog.close();
        return;
      }
      if (target === modal()) close();
    }, true);
    document.addEventListener('change', function (event) {
      if (event.target.matches('[data-viewing-format]')) updateViewing(event.target.closest('form'));
      shareContact(event.target);
    });
    document.addEventListener('input', function (event) {
      shareContact(event.target);
    });
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.id || !form.querySelector('[data-lml-form-feedback]')) return;
      prepareSubmission(form);
      queueMicrotask(function () {
        if (event.defaultPrevented) return;
        try { sessionStorage.setItem(returnKey, JSON.stringify({ id: form.id, path: location.pathname, at: Date.now() })); } catch (e) {}
      });
    }, true);
  }

  function init() {
    var m = modal();
    if (m && m.parentNode !== document.body) document.body.appendChild(m);
    if (m && !m.dataset.bound) {
      m.dataset.bound = 'true';
      m.addEventListener('close', function () {
        if (m.open) return;
        m.classList.remove('is-open');
        document.body.classList.remove('lml-enq-open');
      });
    }
    bind();
    each(document.querySelectorAll('.lml-focused form'), updateViewing);
    each(document.querySelectorAll('[data-shipping-country]'), function (select) {
      if (select.dataset.value) select.value = select.dataset.value;
    });
    setupReturns();
    routeResult();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
  window.lmlEnquiry = { open: open, close: close, isOpen: isOpen };
})();
